// extracted by mini-css-extract-plugin
export default {"proportion_bar":"proportion-bar_proportion_bar__v9ZLw","container":"proportion-bar_container__Gt-xy","section":"proportion-bar_section__3NlvG"};